export default {"src":"/_next/static/media/mileprogram-rank-benefit-rate.ba986b12.svg","height":103,"width":278,"blurWidth":0,"blurHeight":0};